import { render, staticRenderFns } from "./NewSite.vue?vue&type=template&id=672c3260&"
import script from "./NewSite.vue?vue&type=script&lang=ts&"
export * from "./NewSite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports